import { render, staticRenderFns } from "./ResultComponent.html?vue&type=template&id=60b89e52&"
import script from "./ResultComponent.vue?vue&type=script&lang=ts&"
export * from "./ResultComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports